"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryWithPolicy = void 0;
const time_management_1 = require("./time-management");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
/**
 * Creates Retry function for retrying requests using provided retry policy
 */
function retryWithPolicy(send, policy, managerContext) {
    const retryHistory = new Map();
    return (request) => retryRequest(send, policy, retryHistory, managerContext)(request);
}
exports.retryWithPolicy = retryWithPolicy;
/**
 * Retry the request with policy
 */
const retryRequest = (send, policy, history, { globalContext }) => async (request) => {
    let safeSendResult = await safeSend(send)(request);
    for (let count = 0;; count++) {
        const { response, error } = safeSendResult;
        const status = response?.status;
        const result = status || error?.reason || error_interfaces_1.ErrorReason.FailedToFetch;
        const headers = response?.headers;
        const statusCount = history.get(result) || 0;
        history.set(result, statusCount + 1);
        if (policy.shouldRetry(count, result, history, headers)) {
            const nextDelay = policy.nextDelay(count, headers, result);
            const statusResult = (status && http_interfaces_1.Status[status]) || undefined;
            request.operationLogger.nextStep(http_interfaces_1.OperationLogEntryType.RetryDelay, { result: statusResult, resultError: error }, undefined, response);
            await (0, time_management_1.sleep)(nextDelay, globalContext);
            request.operationLogger.nextStep(http_interfaces_1.OperationLogEntryType.Retry, { result: http_interfaces_1.Status[http_interfaces_1.Status.OK] }, request);
            safeSendResult = await safeSend(send)(request);
        }
        else {
            if (error) {
                throw error;
            }
            return safeSendResult.response;
        }
    }
};
const safeSend = (send) => async (request) => {
    try {
        const response = await send(request);
        return { response };
    }
    catch (error) {
        return { response: error.serverResponse, error };
    }
};
